import React from 'react';
import PropTypes from 'prop-types';
import {Grid, colors, makeStyles} from '@material-ui/core';
import {IconImage} from 'components/atoms'
import {SectionHeader, IconAlternate} from 'components/molecules';
import {CardBase, DescriptionListIcon} from 'components/organisms';

const useStyles = makeStyles(() => ({
    fontWeight900: {
        fontWeight: 900,
    }
}));



const data = [
    {
        component: ()=><IconImage url={'https://s3.amazonaws.com/content.rev-lock.com/images/icons/contract.svg'}/>,
        color: colors.indigo,
        title: 'Contract Data',
        subtitle: 'One "source of truth" for accounting\'s interpretation of customer contract data.',
    },
    {
        component: ()=><IconImage url={'https://s3.amazonaws.com/content.rev-lock.com/images/icons/DeferredRevenue.svg'}/>,
        color: colors.indigo,
        title: 'Deferred Revenue Tracking',
        subtitle: 'Tracking of Deferred Revenue at the lowest level with roll-forward and forecasted views.',
    },
    {
        component: ()=><IconImage url={'https://s3.amazonaws.com/content.rev-lock.com/images/icons/revRecRules.svg'}/>,
        color: colors.indigo,
        title: 'Revenue Recognition Rules',
        subtitle: 'Easy-to-use and controlled library for RevRec rules expressed at the level you need.',
    },
    {
        component: ()=><IconImage url={'https://s3.amazonaws.com/content.rev-lock.com/images/icons/SSP.svg'}/>,
        color: colors.indigo,
        title: 'SSP Library / Analyzer',
        subtitle: 'The standalone selling price library (SSP) is a dynamic and easy-to-use Library containing all SSP data at the product level, synced to your price book.',
    },
    {
        component: ()=><IconImage url={'https://s3.amazonaws.com/content.rev-lock.com/images/icons/salesCommission.svg'}/>,
        color: colors.indigo,
        title: 'Sales Commissions',
        subtitle: 'Automated capture and amortization of deferred commission expense over expected life of contract.',
    }, {
        component: ()=><IconImage url={'https://s3.amazonaws.com/content.rev-lock.com/images/icons/complexArrangement.svg'}/>,
        color: colors.indigo,
        title: 'Complex Arrangements',
        subtitle: 'Identification of all performance obligations after factoring in variable considerations per ASC 606.',
    }, {
        component: ()=><IconImage url={'https://s3.amazonaws.com/content.rev-lock.com/images/icons/ledger.svg'}/>,
        color: colors.indigo,
        title: 'Subledger and Journal Entries',
        subtitle: 'Separate accounting vs. reporting period concept, configurable GL account posting logic, automatic prior-period adjustments and true-ups.',
    }, {
        component: ()=><IconImage url={'https://s3.amazonaws.com/content.rev-lock.com/images/icons/analytics.svg'}/>,
        color: colors.indigo,
        title: 'Reporting and Analytics',
        subtitle: 'Real-time reporting of revenue at multiple levels across multiple dimensions and across multiple time periods.  Analyze trends and explain changes with precision. ',
    },
    {
        component: ()=><IconImage url={'https://s3.amazonaws.com/content.rev-lock.com/images/icons/Audit2.svg'}/>,
        color: colors.indigo,
        title: 'Controls and Audit',
        subtitle: 'Accounting systems require higher level of controls.  This includes robust security, user access controls, embedded balance reconciliations, preventative controls for completeness and accuracy.',
    }
];

const Features = ({className, ...rest}) => {
    const classes = useStyles();
    
    return (
       <div id="features" className={className} {...rest}>
           <SectionHeader
              title="Fully Automated Revenue Recognition Solution"
              subtitle="Automation + Controls + User Experience = ASC 606 Done Right"
              fadeUp
              titleProps={{
                  variant: 'h3',
                  color: 'textPrimary',
                  className: classes.fontWeight900,
              }}
           />
           <Grid container spacing={2}>
               {data.map((adv, index) => (
                  <Grid
                     key={index}
                     item
                     container
                     alignItems="center"
                     direction="column"
                     xs={6}
                     md={4}
                     data-aos="fade-up"
                  >
                      <CardBase
                         liftUp
                         variant="outlined"
                         style={{borderTop: `5px solid ${adv.color[500]}`}}
                      >
                          <DescriptionListIcon
                             icon={
                                    <IconAlternate
                                       Component={adv.component}
                                       fontIconClass={adv.icon}
                                       color={adv.color}
                                       shape="circle"
                                       size="small"
                                    />
                             }
                             title={adv.title}
                             subtitle={adv.subtitle}
                             align="left"
                          />
                      </CardBase>
                  </Grid>
               ))}
           </Grid>
       </div>
    );
};

Features.propTypes = {
    /**
     * External classes
     */
    className: PropTypes.string,
};

export default Features;
